import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AccessPermissionService {
  constructor() { }
  userPermission: any[] = [];
  isFullAccess: boolean = false;

  setPermissions(value: any[]) {
    this.userPermission = value;
    localStorage.setItem(
      "accessPermission",
      JSON.stringify(value)
    );
  }

  getPermission() {
    if (this.userPermission.length == 0) {
      let localData = localStorage.getItem("accessPermission") || "";
      this.userPermission = localData != "" ? JSON.parse(localData) : [];
    }
    // console.log("permissions: ",this.userPermission)
    return this.userPermission;
  }

  hasPermission(permission: string) {
    let permissionArray = this.getPermission();
    let isPermission = permissionArray.find(
      (item: any) => item.permissionName == permission
    );
    // this.isFullAccess = localStorage.getItem("isFullAccess") === 'true';
    // if (this.isFullAccess || isPermission) {
    if (isPermission) {
      return true;
    } else {
      return false;
    }
  }

  hasMultiplePermission(permissions: any) {
    let permissionArray = this.getPermission();
    if (!Array.isArray(permissions)) {
      permissions = [permissions];
    }
    // this.isFullAccess = localStorage.getItem("isFullAccess") === 'true';
    // if (this.isFullAccess) {
    //   return true;
    // } else {
    let values = permissionArray.filter((value: any) =>
      permissions.includes(value.permissionName)
    );
    if (values.length > 0) {
      return true;
    } else {
      return false;
    }
    // }
  }

  private dataSource = new BehaviorSubject<boolean>(false);
  closeSidebar = this.dataSource.asObservable();
  updateSidebar(data: boolean) {
    this.dataSource.next(data);
  }

  private showNotification = new BehaviorSubject<boolean>(false);
  displayNotification = this.showNotification.asObservable();
  triggerNotification(data: boolean) {
    this.showNotification.next(data);
  }

  private lastRoute: string = "";
  private lastQueryParams: any = {};

  setLastRoute(route: string, queryParams: any) {
    this.lastRoute = route;
    this.lastQueryParams = queryParams;
  }

  getLastRoute(): string {
    return this.lastRoute;
  }

  getLastQueryParams(): any {
    return this.lastQueryParams;
  }
}
